<div class="navbar navbar-default navbar-fixed-top hidden-xs hidden-sm" style="background: #cd0e11"
  data-testid="top-bar">
  <div class="hidden-sm hidden-xs" style="height: 10px"></div>
  <div class="navbar-header">
    <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
    </button>
    <a [routerLink]="['']">
      <img src="../../../assets/images/UniteHereLogo.png" height="45" width="150"
        style="float: left; align-content: center" data-testid="top-bar-logo" alt="UH logo" />
    </a>
    <!-- <a class="navbar-brand" style="color: white;" href="#/">Strike Module</a> -->
  </div>
  <div class="collapse navbar-collapse">
    <!-- <ul class="nav navbar-nav"> -->
    <!--   <li><a href="#about">About</a></li> -->
    <!-- </ul> -->
    <ul class="nav navbar-nav navbar-right" *ngIf="userData.isUserLoggedIn">
      <li class="userinfo">
        <a style="color: white">
          {{ userData.username }}
          <i class="fa fa-user fa-fw" style="color: white" data-testid="top-bar-username"></i>
        </a>
      </li>
    </ul>
  </div>
</div>
